<template>
    <div class="hot-video-data">
        <!-- 我想要 -->
        <div class="hot-video-data_want">
            <div class="want-data">
                <div class="want-header">
                    <span class="header-label">我想要</span>
                    <i class="iconfont" @click="handleWantCarousel">&#xe603;</i>
                </div>

                <div class="want-data_list" v-draggle-scroll-x>
                    <div
                        :class="['want-item', { 'is-check': currentWantIndex === item.index }]"
                        v-for="item of wantOptions"
                        :key="item.index"
                        @click="handleChangeWant(item.index)"
                    >
                        <div class="want-item_label">{{ item.label }}</div>

                        <div class="want-item_icon">
                            <img :src="item.checkIcon" alt="" v-if="currentWantIndex === item.index" />
                            <img :src="item.defaultIcon" alt="" v-else />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 加热视频选择 -->
        <div class="hot-video-data_video">
            <div class="video-header">我要推广的视频是</div>

            <!-- 账号 -->
            <div class="video-account">
                <img src="@/assets/images/training-logo.png" alt="" class="account-img" />

                <div class="account-info">
                    <div class="account-info_top">一课教育</div>
                    <div class="account-info_bottom">抖音号: Yike_Education</div>
                </div>

                <div class="account-check">切换账号></div>
            </div>

            <!-- 选择视频 -->
            <div class="video-check">
                <div class="check-label">
                    你可选择1~5个无营销属性视频进行投放，已选
                    <span>{{ checkVideoIdList.length }}</span>
                    个
                </div>

                <div class="check-list" v-draggle-scroll-x>
                    <div
                        :class="['video-item', { 'is-check': checkVideoIdList.includes(item.id) }]"
                        v-for="item in videoList"
                        :key="item.id"
                        @click="handleCheckVideo(item)"
                    >
                        <img :src="item.cover" alt="" />

                        <div :class="['item-check', { 'is-check': checkVideoIdList.includes(item.id) }]">
                            <i class="iconfont">&#xe63b;</i>
                        </div>

                        <!-- 播放按钮 -->
                        <div class="play-icon">
                            <i class="iconfont">&#xe628;</i>
                        </div>

                        <!-- 点赞数 -->
                        <div class="digg-count"><i class="iconfont">&#xe631;</i>{{ item.diggCount }}</div>
                    </div>
                </div>

                <div class="check-video-label">
                    {{ getCheckVideoLabel }}
                </div>
            </div>
        </div>

        <!-- 推广方案 -->
        <div class="hot-video-data_promotion">
            <div class="promotion-header">
                <div class="header-label">
                    {{ promotionType === 1 ? "我想选择的套餐是" : "我的推广设置是" }}

                    <!-- <i class="iconfont">&#xe603;</i> -->
                </div>

                <div class="header-change" @click="promotionType = promotionType === 1 ? 2 : 1">
                    <i class="iconfont">&#xe62a;</i>
                    <span>{{ promotionType === 1 ? "自定义推广" : "套餐推广" }}</span>
                </div>
            </div>

            <!-- 套餐推广 -->
            <div class="package-promotion" v-if="promotionType === 1">
                <div
                    :class="['promotion-item', { 'is-check': packagePromotionType === item.index }]"
                    v-for="item in packagePromotionOption"
                    :key="item.index"
                    @click="packagePromotionType = item.index"
                >
                    <div class="promotion-label">{{ item.label }}</div>
                    <div class="promotion-up">预计提升播放量</div>
                    <div class="promotion-count">
                        {{ item.count }}
                        <span>次</span>
                    </div>
                    <div class="promotion-split"></div>
                    <div class="promotion-money">
                        <div class="money-text">￥{{ item.money }}</div>
                        <div class="money-time">{{ item.time }}</div>
                    </div>

                    <div class="promotion-tip">{{ item.tip }}</div>
                </div>
            </div>

            <!-- 自定义推广 -->
            <div class="custom-promotion" v-else>
                <!-- 投放时长 -->
                <div class="promotion-time custom-promotion-item">
                    <div class="item-label">
                        投放时长
                        <i class="iconfont" @click="handleShowTimeTip">&#xe603;</i>
                    </div>

                    <div class="item-value" @click="handleChangeTime">{{ customerPromotion.time }}<i class="el-icon-arrow-right"></i></div>
                </div>

                <!-- 推荐 -->
                <div :class="['promotion-recommend', 'custom-promotion-item', { 'is-custom': customerPromotion.type === 2 }]">
                    <div class="time-label item-label">
                        把视频推荐给潜在兴趣用户
                        <i class="iconfont" @click="handleRecommendInfo">&#xe603;</i>
                    </div>

                    <div class="recommend-check">
                        <div
                            :class="['check-item', { 'is-check': customerPromotion.type === item.index }]"
                            v-for="item in customerRecommandOption"
                            :key="item.index"
                            @click="customerPromotion.type = item.index"
                        >
                            <div class="check-icon"><i class="iconfont">&#xe63b;</i></div>

                            <span>{{ item.label }}</span>
                        </div>
                    </div>
                </div>

                <!-- 自定义推荐 -->
                <template v-if="customerPromotion.type === 2">
                    <div class="promotion-custom-change">
                        <!-- 性别 -->
                        <div class="custom-item">
                            <div class="custom-item_header">性别（单选）</div>

                            <div class="custom-item_list">
                                <div
                                    :class="['list-item', { 'is-check': customerPromotion.sex === item }]"
                                    v-for="item in customOptions.sex"
                                    :key="item"
                                    @click="customerPromotion.sex = item"
                                >
                                    {{ item }}
                                </div>
                            </div>
                        </div>

                        <!-- 年龄 -->
                        <div class="custom-item">
                            <div class="custom-item_header">年龄（多选）</div>

                            <div class="custom-item_list">
                                <div
                                    :class="['list-item', { 'is-check': customerPromotion.age.includes(item) }]"
                                    v-for="item in customOptions.age"
                                    :key="item"
                                    @click="handleChagneAge(item)"
                                >
                                    {{ item }}
                                </div>
                            </div>
                        </div>

                        <!-- 地域 -->
                        <div class="custom-item">
                            <div class="custom-item_header">地域（单选）</div>

                            <div class="custom-item_list">
                                <div
                                    :class="['list-item', { 'is-check': customerPromotion.address === item }]"
                                    v-for="item in customOptions.address"
                                    :key="item"
                                    @click="handleChagneAddress(item)"
                                >
                                    {{ item }}
                                </div>
                            </div>

                            <!-- 选择文本 -->
                            <div
                                class="custom-item_check"
                                v-if="customerPromotion.cityDetail.length > 0 || customerPromotion.countyDetail.length > 0"
                            >
                                <div ref="addressCheckRef" :class="['check-label', { ellipsis: !customerPromotion.addressMore }]">
                                    已选
                                    <span> {{ customerPromotion.cityDetail.length || customerPromotion.countyDetail.length }}个 </span>
                                    地域：
                                    {{ getCityLabels }}
                                </div>

                                <template v-if="customerPromotion.addressShowMore">
                                    <i
                                        class="el-icon-caret-top"
                                        v-if="customerPromotion.addressMore"
                                        @click="customerPromotion.addressMore = !customerPromotion.addressMore"
                                    ></i>
                                    <i
                                        class="el-icon-caret-bottom"
                                        v-else
                                        @click="customerPromotion.addressMore = !customerPromotion.addressMore"
                                    ></i>
                                </template>
                            </div>
                        </div>

                        <!-- 兴趣标签 -->
                        <div class="custom-item">
                            <div class="custom-item_header">兴趣标签（多选）</div>

                            <div class="custom-item_list">
                                <div
                                    :class="['list-item', { 'is-check': getInterestCheck(item) }]"
                                    v-for="item in customOptions.interest"
                                    :key="item"
                                    @click="handleCheckInterest(item)"
                                >
                                    {{ item }}
                                </div>
                            </div>

                            <!-- 选择文本 -->
                            <div class="custom-item_check" v-if="!customerPromotion.interest.includes('不限')">
                                <div ref="interestCheckRef" :class="['check-label', { ellipsis: !customerPromotion.interestMore }]">
                                    已选
                                    <span> {{ customerPromotion.interest.length }}个 </span>
                                    兴趣：
                                    {{ getInterestLabel }}
                                </div>

                                <template v-if="customerPromotion.interestShowMore">
                                    <i
                                        class="el-icon-caret-top"
                                        v-if="customerPromotion.interestMore"
                                        @click="customerPromotion.interestMore = !customerPromotion.interestMore"
                                    ></i>
                                    <i
                                        class="el-icon-caret-bottom"
                                        v-else
                                        @click="customerPromotion.interestMore = !customerPromotion.interestMore"
                                    ></i>
                                </template>
                            </div>
                        </div>

                        <!-- 达人相似粉丝 -->
                        <div class="custom-item">
                            <div class="custom-item_header">达人相似粉丝</div>

                            <div class="custom-item_list">
                                <div
                                    :class="['list-item', { 'is-check': customerPromotion.fan === item }]"
                                    v-for="item in customOptions.fan"
                                    :key="item"
                                    @click="handleChagneChange(item)"
                                >
                                    {{ item }}
                                </div>
                            </div>
                        </div>
                    </div>
                </template>

                <!-- 预计转化数 -->
                <div class="promotion-conversion custom-promotion-item">
                    <div class="time-label item-label">
                        预计带来转化数
                        <i class="iconfont" @click="handleConvertInfo">&#xe603;</i>
                    </div>

                    <div class="conversion-tip">预计提升转化数仅供参考</div>

                    <div class="conversion-value">{{ customerPromotion.money * 50 }}+</div>
                </div>

                <!-- 投放金额 -->
                <div class="promotion-money custom-promotion-item">
                    <div class="time-label item-label">
                        投放金额
                        <i class="iconfont" @click="handlePromotionMoneyInfo">&#xe603;</i>
                    </div>

                    <div class="money-check">
                        <div
                            :class="['check-item', { 'is-check': getPromotionMoneyCheck(item) }]"
                            v-for="item in conversionMoneyOption"
                            :key="item"
                            @click="handleChangeDeliveryMoney(item)"
                        >
                            {{ isNaN(item) ? item : `￥${item}` }}
                        </div>
                    </div>
                </div>

                <!-- 投放策略 -->
                <div class="promotion-strategy custom-promotion-item">
                    <div class="time-label item-label">
                        投放策略
                        <i class="iconfont" @click="handlePromotionMoneyInfo">&#xe603;</i>
                    </div>

                    <div class="strategy-check">
                        <div
                            :class="['check-item', { 'is-check': customerPromotion.strategy === item }]"
                            v-for="item in customOptions.strategy"
                            :key="item"
                            @click="customerPromotion.strategy = item"
                        >
                            {{ item }}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 投放金额 -->
        <div class="hot-video-data_money">
            <div class="money-delivery">
                <span class="delivery-label">投放金额</span>

                <span class="delivery-money">{{ getPayMoney }}</span>
            </div>

            <div class="money-coupon">
                <div class="coupon-label">
                    <i class="iconfont">&#xe64e;</i>
                    <span>优惠券</span>
                </div>

                <span class="coupon-check" @click="handleCheckCoupon">无可用优惠券></span>
            </div>

            <div class="money-split"></div>

            <div class="money-sum">
                <span class="sum-label">
                    优惠与余额说明
                    <i class="iconfont" @click="handlePayInfo">&#xe603;</i>
                </span>

                <span class="sum-money"><span>合计</span>￥{{ getPayMoney }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import { draggleScrollX } from "@/utils/directives.js";
import pcas from "@/utils/training-data/pcas.json";

export default {
    name: "HotVideoData",
    data() {
        return {
            currentWantIndex: 1, // 我想要菜单索引
            currentWantChildIndex: 1, // 我想要子菜单索引
            wantOptions: [
                {
                    index: 1,
                    label: "点赞评论量",
                    checkIcon: require("@/assets/images/training/digg-comment-check.png"),
                    defaultIcon: require("@/assets/images/training/digg-comment-default.png"),
                },
                {
                    index: 2,
                    label: "快速涨粉",
                    checkIcon: require("@/assets/images/training/fan-check.png"),
                    defaultIcon: require("@/assets/images/training/fan-default.png"),
                },
                {
                    index: 3,
                    label: "主页浏览量",
                    checkIcon: require("@/assets/images/training/brower-count-check.png"),
                    defaultIcon: require("@/assets/images/training/brower-count-default.png"),
                },
                {
                    index: 4,
                    label: "智能优化",
                    checkIcon: require("@/assets/images/training/optimiza-check.png"),
                    defaultIcon: require("@/assets/images/training/optimiza-default.png"),
                },
            ],
            checkVideoIdList: [],
            videoList: [
                {
                    id: 1,
                    label: "【日常剧情】-《Ally和超哥连麦 太搞笑了笑死了，势均力敌碰到》",
                    cover: require("@/assets/images/training/video-cover-1.png"),
                    url: "",
                    diggCount: 20,
                },
                {
                    id: 2,
                    label: "韩男男生真的很会，非常有小心机",
                    cover: require("@/assets/images/training/video-cover-2.png"),
                    url: "",
                    diggCount: 30,
                },
                {
                    id: 3,
                    label: "姐妹们以后小东西就不要来我看我了，哈哈哈有没有被内涵到",
                    cover: require("@/assets/images/training/video-cover-3.png"),
                    url: "",
                    diggCount: 40,
                },
            ],
            promotionType: 1, // 1-套餐推广，2-自定义推广
            packagePromotionType: 1, // 1-特惠套餐，2-基础套餐
            packagePromotionOption: [
                {
                    index: 1,
                    label: "特惠套餐",
                    count: "1500+",
                    money: 30,
                    time: "6小时",
                    tip: "价格更低",
                },
                {
                    index: 2,
                    label: "基础套餐",
                    count: "1500+",
                    money: 100,
                    time: "6小时",
                    tip: "效果更好",
                },
            ],
            customerRecommandOption: [
                {
                    index: 1,
                    label: "系统智能推荐",
                },
                {
                    index: 2,
                    label: "自定义定向投放",
                },
            ],
            conversionMoneyOption: [30, 100, 200, 500, 1000, "自定义"],
            customerPromotion: {
                time: "6小时",
                type: 1, // 1-系统智能推荐，2-自定义定向投放
                customMoney: undefined,
                money: 30,
                sex: "不限",
                age: ["不限"],
                address: "全国",
                interest: ["不限"],
                fan: "不限",
                strategy: "保证播放量",

                addressShowMore: false, // 地域是否显示更多符号
                addressMore: false, // 地域是否显示更多
                interestShowMore: false, // 兴趣标签是否显示更多符号
                interestMore: false, // 兴趣标签是否显示更多

                cityDetail: [], // 省市选择详情
                countyDetail: [], //  区县选择详情
                // intersetDetail: [], // 兴趣选择详情
            },
            customOptions: {
                sex: ["不限", "男", "女"],
                age: ["不限", "18-23岁", "24-30岁", "31-40岁", "41-50岁"],
                address: ["全国", "按省市>", "按区县>"],
                interest: ["不限", "生活家电", "装修设计", "箱包", "鞋靴", "酒水", "服饰", "美妆", "更多>"],
                fan: ["不限", "更多>"],
                strategy: ["保证播放量", "最大点赞评论量"],
            },
        };
    },
    mounted() {},
    directives: {
        draggleScrollX: draggleScrollX,
    },
    computed: {
        getCheckVideoLabel() {
            if (this.checkVideoIdList.length === 0) return "";

            const firstCheckVideo = this.videoList.find((video) => video.id === this.checkVideoIdList[0]);
            return firstCheckVideo.label;
        },

        // 获取付款金额
        getPayMoney() {
            if (this.promotionType === 1) {
                // 套餐推广
                const promotionItem = this.packagePromotionOption.find((item) => item.index === this.packagePromotionType);
                const money = promotionItem.money || 0;

                this.$emit("pay-change", money);
                return money;
            } else if (this.promotionType === 2) {
                // 自定义推广
                const money = this.customerPromotion.money;

                this.$emit("pay-change", money);
                return money;
            }
        },

        // 省市-选择城市的文本
        getCityLabels() {
            let nameList = "";

            if (this.customerPromotion.address === "按省市>") {
                const cityList = [];
                pcas.forEach((item) => cityList.push(...item.children));

                const checkCityList = cityList.filter((item) => this.customerPromotion.cityDetail.includes(item.code));
                nameList = checkCityList.map((item) => item.name);
            } else if (this.customerPromotion.address === "按区县>") {
                const cityList = [];
                const countyList = [];
                pcas.forEach((item) => cityList.push(...item.children));
                cityList.forEach((item) => countyList.push(...item.children));

                const checkCityList = countyList.filter((item) => this.customerPromotion.countyDetail.includes(item.code));
                nameList = checkCityList.map((item) => item.name);
            }

            // 计算文本是否超出
            this.$nextTick(() => {
                if (this.$refs.addressCheckRef) {
                    const el = this.$refs.addressCheckRef;
                    this.customerPromotion.addressShowMore = el.scrollWidth > el.clientWidth;
                }
            });

            return nameList.join("、");
        },

        // 选择兴趣标签的文本
        getInterestLabel() {
            // 计算文本是否超出
            this.$nextTick(() => {
                if (this.$refs.interestCheckRef) {
                    const el = this.$refs.interestCheckRef;
                    this.customerPromotion.interestShowMore = el.scrollWidth > el.clientWidth;
                }
            });

            return this.customerPromotion.interest.join("、");
        },
    },
    methods: {
        // 切换我想要菜单项
        handleChangeWant(index) {
            this.currentWantIndex = index;
        },

        // 选择视频
        handleCheckVideo(video) {
            const checkVideoIndex = this.checkVideoIdList.findIndex((item) => item === video.id);

            if (checkVideoIndex !== -1) {
                // 取消选择
                this.checkVideoIdList.splice(checkVideoIndex, 1);
            } else {
                // 选择
                this.checkVideoIdList.push(video.id);
            }
        },

        // 选择投放时间
        handleChangeTime() {
            this.$emit("time-change", this.customerPromotion.time);
        },

        // 确认投放时间
        handleConfirmTime(time) {
            this.customerPromotion.time = time;
        },

        // 修改投放金额
        handleChangeDeliveryMoney(item) {
            if (item !== "自定义") {
                this.customerPromotion.money = item;
                this.customerPromotion.customMoney = undefined;
            } else {
                this.$emit("money-change", this.customerPromotion.customMoney);
            }
        },

        // 选择年龄
        handleChagneAge(item) {
            if (item === "不限") {
                this.customerPromotion.age = ["不限"];
            } else {
                // 清除无限
                const index = this.customerPromotion.age.findIndex((age) => age === "不限");
                if (index !== -1) this.customerPromotion.age.splice(index, 1);

                // 重复点击去掉，否则添加
                const itemIndex = this.customerPromotion.age.findIndex((age) => age === item);

                if (itemIndex !== -1) this.customerPromotion.age.splice(itemIndex, 1);
                else this.customerPromotion.age.push(item);

                if (this.customerPromotion.age.length === 0) {
                    this.customerPromotion.age.push("不限");
                }
            }
        },

        handleChagneChange(item) {},

        // 选择地域
        handleChagneAddress(item) {
            if (item === "按省市>") {
                if (this.customerPromotion.address === "按区县>") {
                    const title = "";
                    const message = "更改地域后，已选地域会被清空，确定修改吗？";
                    const buttonType = 2;

                    this.$emit("show-info", title, message, buttonType);
                } else {
                    this.$emit("address-change", 1, this.customerPromotion.cityDetail);
                }
            } else if (item === "按区县>") {
                if (this.customerPromotion.address === "按省市>") {
                    const title = "";
                    const message = "更改地域后，已选地域会被清空，确定修改吗？";
                    const buttonType = 3;

                    this.$emit("show-info", title, message, buttonType);
                } else {
                    this.$emit("address-change", 2, this.customerPromotion.countyDetail);
                }
            } else if (item === "全国") {
                this.customerPromotion.address = "全国";
                this.customerPromotion.cityDetail = [];
                this.customerPromotion.addressMore = false;
                this.customerPromotion.interestMore = false;
            }
        },

        // 选择地域
        handleConfirmAddress(type, value) {
            this.customerPromotion.cityDetail = [];
            this.customerPromotion.countyDetail = [];
            this.customerPromotion.addressMore = false;

            if (value.length === 0) {
                this.customerPromotion.address = "全国";
                return;
            }

            if (type === 1) {
                // 省市
                this.customerPromotion.address = "按省市>";
                this.customerPromotion.cityDetail = value;
            } else if (type === 2) {
                // 区县
                this.customerPromotion.address = "按区县>";
                this.customerPromotion.countyDetail = value;
            }
        },

        // 投放时长-弹框提示
        handleShowTimeTip() {
            const title = "投放时长";
            const message = "此投放时长为预估时长，订单以实际消耗情况为主";
            const buttonType = 1;

            this.$emit("show-info", title, message, buttonType);
        },

        // 推荐潜在用户，提示
        handleRecommendInfo() {
            const title = "把视频推荐给潜在兴趣用户";
            const message = "将视频展现给推荐流更多潜在兴趣用户，提升视频的播放量";

            this.$emit("show-info", title, message, 1);
        },

        // 带来转化数，提示
        handleConvertInfo() {
            const title = "预计带来转化数说明";
            const message =
                "系统将根据你的预算及投放时长设置实时估算预计转化数，实际投放效果会收到视频内容质量、投放时间等因素影响，预计转化数仅供参考，不做为投放效果保证。";

            this.$emit("show-info", title, message, 1);
        },

        // 投放金额-提示
        handlePromotionMoneyInfo() {
            const title = "投放金额";
            const message =
                "投放金额为此次投放的最大消耗值，系统会尽可能100%投放完成。但投放过程中若遇到如视频删除/设好友可见或私密/人工举报/投放效率不佳，系统会自动结束投放。剩余未消耗的金额将4~48小时可退回DOU+账户。";

            this.$emit("show-info", title, message, 1);
        },

        // 优惠与余额说明
        handlePayInfo() {
            const title = "优惠与余额说明";
            const message =
                "赠款余额包含活动赠款和其他赠款，其中活动赠款主要来源于各类营销活动，与优惠券不可同时使用；其他赠款来源于系统赔付；当有余额处于退款状态时，退款中的余额会被暂时冻结不可使用。";

            this.$emit("show-info", title, message, 1);
        },

        // 兴趣标签是否选中
        getInterestCheck(item) {
            if (item === "更多>") {
                const defaultInterest = ["生活家电", "装修设计", "箱包", "鞋靴", "酒水", "服饰", "美妆"];

                for (let i = 0; i < this.customerPromotion.interest.length; i++) {
                    const interestItem = this.customerPromotion.interest[i];

                    if (!defaultInterest.includes(interestItem) && interestItem !== "不限") {
                        return true;
                    }
                }

                return false;
            } else {
                return this.customerPromotion.interest.includes(item);
            }
        },

        // 选择兴趣标签
        handleCheckInterest(item) {
            if (item === "不限") {
                this.customerPromotion.interest = ["不限"];
            } else if (item === "更多>") {
                const interestList = JSON.parse(JSON.stringify(this.customerPromotion.interest));

                const allIndex = interestList.findIndex((tag) => tag === "不限");
                if (allIndex !== -1) interestList.splice(allIndex, 1);

                this.$emit("interest-change", interestList);
            } else {
                const itemIndex = this.customerPromotion.interest.findIndex((tag) => item === tag);

                if (itemIndex !== -1) {
                    this.customerPromotion.interest.splice(itemIndex, 1);
                } else {
                    this.customerPromotion.interest.push(item);

                    const allIndex = this.customerPromotion.interest.findIndex((tag) => tag === "不限");
                    if (allIndex !== -1) this.customerPromotion.interest.splice(allIndex, 1);
                }

                if (this.customerPromotion.interest.length === 0) {
                    this.customerPromotion.interest = ["不限"];
                }
            }
        },

        // 确认兴趣标签
        handleConfirmInterest(tags) {
            this.customerPromotion.interestMore = false;

            if (tags.length === 0) {
                this.customerPromotion.interest = ["不限"];
                return;
            }

            this.customerPromotion.interest = [...tags];
        },

        // 选择优惠券
        handleCheckCoupon() {
            this.$emit("coupon-change");
        },

        // 确认自定义金额
        handleConfirmMoney(money) {
            this.customerPromotion.customMoney = money;
            this.customerPromotion.money = money;
        },

        // 投放金额选中状态
        getPromotionMoneyCheck(item) {
            if (item === "自定义") {
                return this.customerPromotion.customMoney !== undefined;
            } else {
                return this.customerPromotion.customMoney === undefined && item === this.customerPromotion.money;
            }
        },

        // 想要轮播图
        handleWantCarousel() {
            this.$emit("want-show");
        },
    },
};
</script>

<style lang="scss" scoped>
.hot-video-data {
    padding: 12px;
    width: 100%;
    box-sizing: border-box;
    font-family: PingFang-SC;
    // position: relative;

    & > * {
        box-sizing: border-box;
    }

    &_want {
        padding: 16px;
        background-color: #ffffff;
        border-radius: 8px;

        .want-header {
            font-family: PingFang-SC;
            font-size: 15px;
            font-weight: 500;
            line-height: 15px;
            color: #323233;

            .header-label {
                font-weight: 600;
            }

            .iconfont {
                font-size: 13px;
                margin-left: 2px;
                cursor: pointer;
            }
        }

        .want-data {
            &_list {
                display: flex;
                gap: 10px;
                margin-top: 10px;

                .want-item {
                    flex-shrink: 0;
                    background-color: #ffffff;
                    border: 1px solid #e4e7ed;
                    border-radius: 8px;
                    cursor: pointer;
                    width: 90px;
                    height: 80px;
                    padding: 10px;
                    box-sizing: border-box;
                    font-size: 13px;

                    &.is-check {
                        background-color: #fff3f5;
                        border-color: #f7edef;
                        color: #fc2b55;
                    }

                    &_icon {
                        display: flex;
                        justify-content: flex-end;
                        // padding-right: 5px;

                        img {
                            width: 48px;
                            height: 48px;
                            object-fit: cover;
                            transform: translateX(5px);
                        }
                    }
                }
            }
        }

        .want-more {
            margin-top: 30px;
        }
    }

    &_video {
        margin-top: 20px;
        padding: 16px;
        background-color: #ffffff;
        border-radius: 8px;

        .video-header {
            font-family: PingFang-SC;
            font-size: 15px;
            font-weight: 500;
            line-height: 15px;
            color: #323233;
            font-weight: 600;
        }

        .video-account {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 16px;
            height: 48px;
            // gap: 4px;
            padding-bottom: 16px;
            border-bottom: 1px solid #f4f4f4;

            .account-img {
                width: 48px;
                height: 48px;
                // background-color: rgba(0, 0, 0, 0.5);
                border-radius: 50%;
                object-fit: cover;
            }

            .account-info {
                margin-left: 10px;
                flex: 1;
                display: flex;
                flex-direction: column;
                justify-content: center;
                font-size: 13px;
                gap: 6px;

                &_bottom {
                    color: #999999;
                    font-size: 12px;
                }
            }

            .account-check {
                width: 60px;
                font-size: 13px;
                color: #999999;
            }
        }

        .video-check {
            margin-top: 16px;

            .check-label {
                font-size: 12px;
                color: #999999;

                span {
                    color: #fc2b55;
                }
            }

            .check-list {
                display: flex;
                gap: 20px;
                margin-top: 10px;

                .video-item {
                    flex-shrink: 0;
                    width: 116px;
                    height: 156px;
                    border-radius: 8px;
                    overflow: hidden;
                    position: relative;
                    cursor: pointer;
                    box-sizing: border-box;
                    border: 1px solid rgba(0, 0, 0, 0);

                    img {
                        height: 100%;
                        width: 100%;
                        object-fit: cover;
                    }

                    &.is-check {
                        border: 1px solid #fc2b55;
                    }

                    .item-check {
                        position: absolute;
                        right: 6px;
                        top: 6px;
                        border-radius: 50%;
                        border: 1px solid #fc2b55;
                        width: 20px;
                        height: 20px;
                        overflow: hidden;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        box-sizing: border-box;

                        .iconfont {
                            color: #fc2b55;
                            background-color: #ffffff;
                            border-radius: 50%;
                            font-size: 20px;
                            width: 20px;
                            height: 20px;
                        }

                        &:not(.is-check) {
                            border-color: #ffffff;

                            .iconfont {
                                display: none;
                            }
                        }
                    }

                    .play-icon {
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        color: #ffffff;

                        .iconfont {
                            font-size: 30px;
                        }
                    }

                    .digg-count {
                        position: absolute;
                        color: #ffffff;
                        left: 5px;
                        bottom: 5px;
                        font-size: 14px;

                        .iconfont {
                            font-weight: bold;
                            margin-right: 4px;
                            font-size: 14px;
                        }
                    }
                }
            }

            .check-video-label {
                margin-top: 8px;
                width: 100%;
                color: #323233;
                font-size: 13px;
                white-space: nowrap; /* 强制单行显示 */
                overflow: hidden; /* 超出部分隐藏 */
                text-overflow: ellipsis; /* 显示省略号 */
            }
        }
    }

    &_promotion {
        margin-top: 20px;
        padding: 16px;
        background-color: #ffffff;
        border-radius: 8px;

        .promotion-header {
            color: #323233;
            font-size: 14px;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .header-label {
                font-weight: 600;
            }

            .iconfont {
                font-weight: 500;
                color: #999999;
                font-size: 14px;
            }

            .header-change {
                color: #999999;
                font-size: 13px;
                cursor: pointer;

                .iconfont {
                    font-size: 13px;
                    margin-right: 5px;
                }
            }
        }

        .package-promotion {
            display: flex;
            gap: 10px;
            margin-top: 10px;

            .promotion-item {
                position: relative;
                padding: 12px;
                background-color: #f5f5f5;
                border: 1px solid rgba(0, 0, 0, 0);
                width: calc((100% - 10px) / 2);
                border-radius: 8px;
                overflow: hidden;
                cursor: pointer;
                font-size: 13px;
                color: #323233;

                .promotion-label {
                    font-weight: 600;
                }

                .promotion-up {
                    margin-top: 5px;
                    font-size: 13px;
                }

                .promotion-split {
                    margin-top: 5px;
                    height: 1px;
                    width: 100%;
                    border-top: 1px dashed #f1f1f1;
                }

                .promotion-count {
                    margin-top: 5px;
                    font-size: 22px;
                    font-weight: 600;

                    span {
                        font-size: 13px;
                    }
                }

                .promotion-money {
                    margin-top: 5px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;

                    .money-text {
                        font-weight: 600;
                        padding-right: 10px;
                        // border-right: 1px solid #f1f1f1;
                    }

                    .money-time {
                        color: #999999;
                    }
                }

                .promotion-tip {
                    position: absolute;
                    background-color: #fc2b55;
                    padding: 2px 6px;
                    border-bottom-left-radius: 6px;
                    top: 0;
                    right: 0;
                    color: #ffffff;
                    font-size: 11px;
                }

                &.is-check {
                    border-color: #fc2b55;
                    background-color: #ffffff;

                    .promotion-label,
                    .promotion-count,
                    .promotion-money .money-text {
                        color: #fc2b55;
                    }
                }
            }
        }

        .custom-promotion {
            .custom-promotion-item {
                font-size: 13px;
                margin-top: 16px;
                padding-bottom: 16px;
                border-bottom: 1px solid #f1f1f1;

                .item-label {
                    .iconfont {
                        font-size: 13px;
                        color: #999999;
                        cursor: pointer;
                    }
                }

                .item-value {
                    cursor: pointer;
                    i {
                        color: #999999;
                        font-size: 13px;
                    }
                }
            }

            .promotion-time {
                display: flex;
                justify-content: space-between;
                align-items: center;
            }

            .promotion-recommend {
                &.is-custom {
                    border-bottom: none;
                    padding: 0px;
                }

                .recommend-check {
                    margin-top: 10px;

                    .check-item {
                        display: flex;
                        align-items: center;
                        gap: 4px;
                        margin-top: 8px;
                        cursor: pointer;

                        .check-icon {
                            border-radius: 50%;
                            width: 14px;
                            height: 14px;
                            border: 1px solid #dddddd;
                            display: flex;
                            align-items: center;

                            .iconfont {
                                background-color: #ffffff;
                                color: #fc2b55;
                                border-radius: 50%;
                                display: none;
                            }
                        }

                        &.is-check {
                            border-color: #fc2b55;

                            .iconfont {
                                display: block;
                            }
                        }
                    }
                }
            }

            .promotion-conversion {
                .conversion-tip {
                    color: #999999;
                    margin-top: 8px;
                }

                .conversion-value {
                    font-size: 30px;
                    color: #fc2b55;
                    text-align: center;
                    font-weight: 600;
                    padding-top: 10px;
                }
            }

            .promotion-money {
                .money-check {
                    display: flex;
                    gap: 10px;
                    flex-wrap: wrap;
                    margin-top: 10px;

                    .check-item {
                        flex-shrink: 0;
                        width: calc((100% - 30px) / 3);
                        height: 30px;
                        border-radius: 4px;
                        border: 1px solid #f1f1f1;
                        text-align: center;
                        line-height: 30px;
                        cursor: pointer;

                        &.is-check {
                            border-color: #fee3e8;
                            background-color: #fff3f5;
                            color: #fc2b55;
                        }
                    }
                }
            }

            .promotion-strategy {
                border-bottom: none;

                .strategy-check {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    gap: 10px;
                    margin-top: 10px;
                    cursor: pointer;

                    .check-item {
                        width: calc((100% - 20px) / 2);
                        color: #323233;
                        padding-block: 6px;
                        background-color: #f5f5f5;
                        border: 1px solid rgba(0, 0, 0, 0);
                        text-align: center;
                        border-radius: 4px;

                        &.is-check {
                            border: 1px solid #fc2b55;
                            background-color: #ffffff;
                            color: #fc2b55;
                        }
                    }
                }
            }

            .promotion-custom-change {
                padding-bottom: 20px;
                border-bottom: 1px solid #f1f1f1;

                .custom-item {
                    margin-top: 8px;
                    margin-bottom: 20px;
                    font-size: 14px;

                    &_header {
                        color: #999999;
                        font-size: 13px;
                    }

                    &_list {
                        display: flex;
                        gap: 10px;
                        flex-wrap: wrap;
                        margin-top: 8px;

                        .list-item {
                            width: calc((100% - 30px) / 3);
                            border: 1px solid #f1f1f1;
                            border-radius: 4px;
                            height: 26px;
                            line-height: 26px;
                            text-align: center;
                            cursor: pointer;

                            &.is-check {
                                border-color: #fee3e8;
                                background-color: #fff3f5;
                                color: #fc2b55;
                            }
                        }
                    }

                    &_check {
                        margin-top: 4px;
                        position: relative;

                        .check-label {
                            width: calc(100% - 21px);
                            color: #89888d;
                            font-size: 12px;

                            span {
                                color: #fc2b55;
                            }

                            &.ellipsis {
                                white-space: nowrap; /* 强制单行显示 */
                                overflow: hidden; /* 超出部分隐藏 */
                                text-overflow: ellipsis; /* 显示省略号 */
                            }
                        }

                        i {
                            font-size: 16px;
                            cursor: pointer;
                            color: #89888d;
                            position: absolute;
                            top: 0;
                            right: 0;
                        }
                    }
                }
            }
        }
    }

    &_money {
        margin-top: 20px;
        padding: 16px;
        background-color: #ffffff;
        border-radius: 8px;

        .money-delivery,
        .money-coupon,
        .money-sum {
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

        .money-delivery {
            font-size: 13px;

            .delivery-money {
                font-weight: 600;
            }
        }

        .money-coupon {
            margin-top: 16px;
            font-size: 13px;

            .coupon-label {
                display: flex;
                align-items: center;
                gap: 4px;

                .iconfont {
                    color: #fc2b55;
                }
            }

            .coupon-check {
                color: #999999;
                cursor: pointer;
            }
        }

        .money-split {
            width: 100%;
            height: 1px;
            background-color: #f1f1f1;
            margin-block: 16px;
        }

        .money-sum {
            font-size: 14px;

            .sum-label {
                color: #999999;

                .iconfont {
                    font-size: 14px;
                    cursor: pointer;
                }
            }

            .sum-money {
                span {
                    font-weight: 400;
                }

                font-weight: 600;
            }
        }
    }
}
</style>
